import { cva } from 'class-variance-authority';

import s from './IconButton.module.css';

export const iconButtonVariants = cva(s.iconButton, {
  variants: {
    size: {
      default: s['iconButton--size-default'],
      small: s['iconButton--size-small'],
    },
  },
});
